import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component, HostBinding,
  Input,
  OnDestroy,
  OnInit
} from '@angular/core';
import { LMFieldBaseComponent } from '../lm-field-base.component'
import { LMFieldServiceAdapter } from '../lm-field-service-adapter';
import { LMModel, LMModelChangedEvent } from '../../form/model';
import { LMProcessIndicatorService } from './lm-process-indicator.service';

@Component({
  selector: 'lm-process-indicator',
  templateUrl: 'lm-process-indicator.component.html',
  styleUrls: ['lm-process-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LMProcessIndicatorComponent extends LMFieldBaseComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() layoutObject: LMFormLayoutField;
  @Input() specFields: LMSpecFields;
  @Input() model: LMModel;
  @Input() templateData: Array<LMProcessIndicatorDisplayData>;
  @Input() processIndicatorCompletionStatus: LMProcessIndicatorCompletionStatus;
  @Input() lmParagraphLayoutInfo: LMParagraphLayoutInfo;
  @Input() lmColumnLayoutInfo: LMColumnLayoutInfo;

  @HostBinding('class.parent-is-paragraph') parentIsParagraph: boolean;
  @HostBinding('attr.id') dataAutomationId: string;

  public processIndicatorResponsiveDisplayData: LMProcessIndicatorDisplayData;

  constructor(
    protected lmFieldServiceAdapter: LMFieldServiceAdapter,
    private lmProcessIndicatorService: LMProcessIndicatorService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    super(lmFieldServiceAdapter);
  }

  ngOnInit() {
    super.ngOnInit();
    this.initialize(this.layoutObject, this.specFields, this.model);
    this.build();
    this.subscribeToModelChanges();
    this.dataAutomationId = this.id;
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  public getStepId(data: LMProcessIndicatorDisplayData): string {
    return `${this.id}_${data.stepId}`;
  }

  public getStepOverflowId(data: LMProcessIndicatorDisplayData): string {
    return `${this.id}_${data.stepId}-step-approvers-overflow`;
  }

  private build() {
    if (this.lmParagraphLayoutInfo) {
      this.parentIsParagraph = this.lmParagraphLayoutInfo.parentIsParagraphLayout;
    }

    if (this.modelField.value === '') {
      this.templateData = null;
    } else {
      const processIndicatorData: LMProcessIndicatorData = JSON.parse(this.modelField.value);
      this.templateData = this.lmProcessIndicatorService.getTemplateData(processIndicatorData);
      this.processIndicatorCompletionStatus = processIndicatorData.completionStatus;
      this.processIndicatorResponsiveDisplayData = this.lmProcessIndicatorService.getStepInProgress(this.templateData);
    }

    this.changeDetectorRef.markForCheck();
  }

  private subscribeToModelChanges() {
    this.subscriptionArray.push(this.model.modelChanged
      .subscribe((modelChangedEvent: LMModelChangedEvent) => {
        if (modelChangedEvent.eventType === 'set') {
          this.build();
        }
      })
    );
  }
}
